let view = null;

export default {
	namespace: 'single-press',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: SinglePressView } = await import(
			/* webpackChunkName: "single-press-view" */ '../../templates/SinglePressView'
		);
		view = new SinglePressView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
